(function () {
  var TOAST_DURATION = 8000;

  var wrap, toast, countdownFill;
  var rafId = null;
  var startTime = null;
  var remaining = TOAST_DURATION;
  var paused = false;
  var isVisible = false;
  var escHandler = null;

  function resolveElements() {
    wrap = document.getElementById('aigoToast');
    toast = wrap && wrap.querySelector('.aigo-toast');
    countdownFill = toast && toast.querySelector('[data-toast-countdown]');
  }

  function populateSlots(payload) {
    var itemsEl = toast.querySelector('[data-toast-items]');
    if (itemsEl) itemsEl.textContent = payload.itemCount + ' item' + (payload.itemCount !== 1 ? 's' : '');

    var namesEl = toast.querySelector('[data-toast-item-names]');
    if (namesEl) namesEl.textContent = payload.itemNames || '';

    var currencyEl = toast.querySelector('[data-toast-currency]');
    if (currencyEl) currencyEl.textContent = payload.currency || 'USD';

    var totalEl = toast.querySelector('[data-toast-total]');
    if (totalEl) {
      var amount = parseFloat(payload.estimatedTotal);
      // draft_order.total_price from Shopify API is a string like "372.70"
      totalEl.textContent = isNaN(amount) ? (payload.estimatedTotal || '') : ('~$' + amount.toFixed(2));
    }

    var shippingEl = toast.querySelector('[data-toast-shipping]');
    if (shippingEl) shippingEl.textContent = payload.shippingTitle || 'Free Delivery';

    var discountRowEl = toast.querySelector('[data-toast-discount]');
    var discountAmtEl = toast.querySelector('[data-toast-discount-amt]');
    if (discountRowEl) {
      if (payload.discountTotal && discountAmtEl) {
        discountAmtEl.textContent = '\u2212$' + parseFloat(payload.discountTotal).toFixed(2);
        discountRowEl.style.display = '';
      } else {
        discountRowEl.style.display = 'none';
      }
    }

    // Hide divider if no rows below it are visible
    var dividerEl = toast.querySelector('[data-toast-divider]');
    if (dividerEl) {
      var hasDiscount = discountRowEl && discountRowEl.style.display !== 'none';
      var totalRowEl = toast.querySelector('.aigo-toast__total');
      var hasTotal = totalRowEl && totalRowEl.style.display !== 'none';
      var hasShipping = shippingEl && shippingEl.textContent.trim() !== '';
      dividerEl.style.display = (hasDiscount || hasTotal || hasShipping) ? '' : 'none';
    }
  }

  function tick(now) {
    if (paused) return;
    var elapsed = now - startTime;
    var left = remaining - elapsed;
    var progress = Math.max(0, left / TOAST_DURATION);
    if (countdownFill) countdownFill.style.transform = 'scaleX(' + progress + ')';
    if (left <= 0) {
      hideToast();
    } else {
      rafId = requestAnimationFrame(tick);
    }
  }

  function startTick() {
    startTime = performance.now();
    rafId = requestAnimationFrame(tick);
  }

  function pauseCountdown() {
    if (!paused && isVisible) {
      paused = true;
      remaining = remaining - (performance.now() - startTime);
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    }
  }

  function resumeCountdown() {
    if (paused && isVisible) {
      paused = false;
      startTick();
    }
  }

  function showToast() {
    if (!toast) return;
    toast.classList.remove('is-hiding');
    if (countdownFill) countdownFill.style.transform = 'scaleX(1)';
    toast.offsetHeight; // force reflow so transition fires
    toast.classList.add('is-visible');
    isVisible = true;
    remaining = TOAST_DURATION;
    paused = false;
    startTick();

    // Hover pause — desktop only
    if (!window.matchMedia('(max-width: 900px)').matches) {
      toast.addEventListener('mouseenter', pauseCountdown);
      toast.addEventListener('mouseleave', resumeCountdown);
    }

    // Escape key
    escHandler = function (e) {
      if (e.key === 'Escape' && isVisible) hideToast();
    };
    document.addEventListener('keydown', escHandler);
  }

  function hideToast() {
    if (!toast || !isVisible) return;
    isVisible = false;
    if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    toast.removeEventListener('mouseenter', pauseCountdown);
    toast.removeEventListener('mouseleave', resumeCountdown);
    if (escHandler) { document.removeEventListener('keydown', escHandler); escHandler = null; }
    toast.classList.remove('is-visible');
    toast.classList.add('is-hiding');
    setTimeout(function () {
      toast.classList.remove('is-hiding');
      window.location.href = '/';
    }, 320);
  }

  function handleOrderCreated(payload) {
    resolveElements();
    if (!toast) return;
    populateSlots(payload);
    showToast();
  }

  // Dismiss button delegation
  document.addEventListener('click', function (e) {
    if (!isVisible) return;
    if (e.target.closest('[data-toast-close]') || e.target.closest('[data-toast-dismiss]')) {
      hideToast();
    }
  });

  // Subscribe — both scripts are defer so FoxTheme (from theme.js) is ready by DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function () {
    if (window.FoxTheme && FoxTheme.pubsub) {
      FoxTheme.pubsub.subscribe(
        FoxTheme.pubsub.PUB_SUB_EVENTS.draftOrderCreated,
        handleOrderCreated
      );
    }
  });
})();
